const settings = {
  api: process.env.REACT_APP_API_URL || 'http://localhost:1337',
  workerApi: process.env.REACT_APP_WORKER_API_URL || 'http://localhost:3001',
  routesMap: {
    authenticated: '/plataforma/estudiantes',
    parent: '/plataforma/acudientes',
    teacher: '/plataforma/profesores',
    admin: '/plataforma/administrador',
    secretary_admin: '/plataforma/administrador',
    supervisor_admin: '/plataforma/administrador',
    content_admin: '/plataforma/contenido',
    affiliate: '/plataforma/afiliados',
    adviser: '/plataforma/asesoras',
    community: '/plataforma/administrador',
    coordinator: '/plataforma/administrador',
    school: '/plataforma/school',
  },
};

export default settings;
